<template>
  <validation-observer
    id="stepIntroForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <vvs-input
      type="email"
      name="E-Posta"
      label="1. E-posta"
      placeholder="Vivense'de kullanacağınız e-posta adresini girin."
      validate="required|email|withoutEmoji"
      validate-mode="lazy"
      v-model="form.email"
    ></vvs-input>

    <vvs-input
      type="tel"
      name="Telefon"
      label="2. Telefon"
      placeholder="0(___) ___ __ __"
      mask="0(###) ### ## ##"
      validate="required|min:16"
      validate-mode="lazy"
      v-model="form.phoneNumber"
    ></vvs-input>

    <vvs-textarea
      name="Firma Adı"
      label="3. Firma Adı"
      placeholder="Vergi levhasında bulunan ticaret ünvanını girin. Şahıs şirketi iseniz adınızı ve soyadınızı yazın."
      validate="required|withoutEmoji|min:2"
      maxlength="150"
      v-model="form.companyName"
      auto-resize
    ></vvs-textarea>

    <vvs-address
      label="4. Mağaza lokasyon bilgilerinizi giriniz"
      :address.sync="form.location"
    ></vvs-address>

    <vvs-uploader
      name="Mağaza Fotoğrafları"
      label="5. Mağazanız fotoğraflarını yükleyin"
      description="Yüklenen dosyalar jpeg, jpg, veya png uzantılı olmalıdır."
      accept="image/jpeg,image/png"
      accept-text="jpeg, jpg veya png"
      v-model="form.photos"
    ></vvs-uploader>


    <vvs-questions
      :questions.sync="questions"
      :form-questions="form.questions"
      :static-questions="staticQuestions"
      :question-start-number="6"
    ></vvs-questions>
    
    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="BAŞVURUYU TAMAMLAYIN"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';
import staticQuestions from '@/data/seller-questions';

export default {
  name: 'StepIntro',
  mixins: [stepsMixin],
  data() {
    return {
      questions: [],
      staticQuestions: staticQuestions,
    };
  },
};
</script>
